import * as React from "react";

const PriceTagIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path
                d="M0 1.125V4.62891C0 5.02734 0.157031 5.40937 0.438281 5.69062L4.56328 9.81562C5.14922 10.4016 6.09844 10.4016 6.68438 9.81562L9.81328 6.68672C10.3992 6.10078 10.3992 5.15156 9.81328 4.56562L5.68828 0.440625C5.40703 0.159375 5.025 0.00234371 4.62656 0.00234371L1.125 0C0.503906 0 0 0.503906 0 1.125ZM2.625 1.875C2.82391 1.875 3.01468 1.95402 3.15533 2.09467C3.29598 2.23532 3.375 2.42609 3.375 2.625C3.375 2.82391 3.29598 3.01468 3.15533 3.15533C3.01468 3.29598 2.82391 3.375 2.625 3.375C2.42609 3.375 2.23532 3.29598 2.09467 3.15533C1.95402 3.01468 1.875 2.82391 1.875 2.625C1.875 2.42609 1.95402 2.23532 2.09467 2.09467C2.23532 1.95402 2.42609 1.875 2.625 1.875Z"
                fill="#636161"
            />
        </svg>
    );
};

export default React.memo(PriceTagIcon);
